<template>
    <div class="start-wrapper">
        <header>
            <div class="content-header">
                <svg
                    width="124"
                    height="42"
                    viewBox="0 0 124 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M32.4686 37.8791C32.4051 37.655 32.2985 37.4457 32.155 37.2633C32.0115 37.0809 31.8338 36.929 31.6321 36.8162C31.4305 36.7035 31.2088 36.6321 30.9799 36.6062C30.7509 36.5803 30.5191 36.6004 30.2979 36.6653C24.9011 38.2311 16.2002 39.4085 13.9336 37.1205C11.6669 34.8325 14.4433 27.4465 16.656 21.5049C19.6542 13.5484 22.4365 6.0228 18.5748 2.11435C14.3773 -2.13397 2.58233 1.26469 1.25712 1.67131C1.03584 1.73786 0.829679 1.84787 0.650409 1.99506C0.471138 2.14225 0.322266 2.32373 0.212294 2.52915C0.102322 2.73456 0.0334027 2.9599 0.00947159 3.19227C-0.0144595 3.42465 0.00706615 3.65952 0.0728194 3.88347C0.138573 4.10743 0.247266 4.31608 0.392693 4.49752C0.53812 4.67897 0.717434 4.82964 0.920395 4.94094C1.12336 5.05225 1.34599 5.122 1.57559 5.14622C1.80518 5.17044 2.03724 5.14866 2.25852 5.08211C6.82781 3.71051 14.1375 2.65449 16.0863 4.633C18.341 6.91495 15.5826 14.307 13.3639 20.2486C10.3657 28.2112 7.58336 35.7307 11.4451 39.6695C12.9802 41.2171 15.6426 42 19.2824 42C24.4693 42 30.1719 40.4342 31.2753 40.1186C31.5009 40.0541 31.7114 39.9443 31.8944 39.7959C32.0773 39.6474 32.2289 39.4633 32.3402 39.2544C32.4515 39.0456 32.5202 38.8162 32.5422 38.58C32.5643 38.3437 32.5392 38.1054 32.4686 37.8791V37.8791Z"
                        fill="#00F3FF"
                    />
                    <path
                        d="M10.9921 15.3897C11.0261 15.4241 11.0509 15.4673 11.064 15.5149C11.0771 15.5625 11.0781 15.6129 11.0669 15.661L10.7104 18.6756C10.689 18.7758 10.6412 18.8677 10.5725 18.9409C10.5398 18.9769 10.5006 19.0056 10.4571 19.0253C10.4137 19.045 10.3668 19.0552 10.3195 19.0554H7.49666C7.45386 19.0568 7.41267 19.0729 7.37943 19.1012C7.34619 19.1296 7.32275 19.1685 7.31269 19.2122L5.9329 31.1199C5.91602 31.2205 5.86982 31.3132 5.80067 31.3852C5.76808 31.4229 5.72805 31.4526 5.68337 31.4724C5.63869 31.4922 5.59043 31.5015 5.54195 31.4998H2.12122C2.07516 31.5024 2.02917 31.4933 1.98714 31.4734C1.94512 31.4535 1.90828 31.4232 1.87975 31.3852C1.8506 31.349 1.83016 31.3061 1.82016 31.2599C1.81015 31.2137 1.81087 31.1657 1.82226 31.1199L3.2308 19.1881C3.23368 19.1668 3.23179 19.1451 3.2253 19.1247C3.21881 19.1043 3.20788 19.0858 3.19338 19.0706C3.17888 19.0554 3.16121 19.0439 3.14176 19.0371C3.12231 19.0303 3.10162 19.0283 3.08132 19.0313H1.35658C1.3116 19.0321 1.26705 19.0221 1.22624 19.0023C1.18542 18.9825 1.14941 18.9532 1.12086 18.9168C1.09072 18.8812 1.06923 18.8384 1.05822 18.7923C1.0472 18.7461 1.047 18.6978 1.05762 18.6515L1.41982 15.6369C1.41954 15.5851 1.43022 15.5339 1.4511 15.487C1.47198 15.4401 1.50253 15.3986 1.54055 15.3656C1.61375 15.2939 1.71067 15.255 1.81076 15.257H3.5355C3.63324 15.257 3.67923 15.2028 3.67923 15.1003L3.77122 14.4069C3.86192 13.3432 4.17605 12.3136 4.69108 11.3923C5.15719 10.6554 5.85179 10.1102 6.65729 9.84881C7.78809 9.51822 8.96428 9.39181 10.1355 9.475H11.2164C11.4406 9.475 11.5498 9.60162 11.5498 9.85484L11.2508 12.4052C11.2294 12.5054 11.1816 12.5973 11.1129 12.6705C11.08 12.7057 11.0406 12.7335 10.9971 12.7521C10.9536 12.7708 10.9069 12.78 10.8599 12.779H9.8998C9.36783 12.7462 8.8415 12.9082 8.41078 13.2372C8.0551 13.6715 7.85217 14.2206 7.83586 14.7928L7.77837 15.1425C7.77837 15.245 7.81861 15.2992 7.8991 15.2992H10.7219C10.7705 15.2934 10.8197 15.2984 10.8663 15.314C10.9129 15.3296 10.9558 15.3554 10.9921 15.3897V15.3897Z"
                        fill="white"
                    />
                    <path
                        d="M30.5698 14.8297C30.6028 14.792 30.6431 14.762 30.6881 14.7418C30.7332 14.7216 30.7818 14.7116 30.8308 14.7125H34.3302C34.377 14.7117 34.4234 14.7217 34.4659 14.7418C34.5085 14.7619 34.5463 14.7917 34.5764 14.8289C34.6065 14.8662 34.6283 14.9099 34.6401 14.957C34.6518 15.0041 34.6534 15.0533 34.6445 15.1011L32.7822 30.8835C32.7647 30.9864 32.7171 31.0812 32.6457 31.1548C32.6116 31.1927 32.5703 31.2228 32.5243 31.2429C32.4783 31.2631 32.4287 31.273 32.3788 31.272H28.8795C28.8321 31.2737 28.7849 31.264 28.7417 31.2437C28.6985 31.2234 28.6604 31.193 28.6304 31.1548C28.6003 31.1178 28.5792 31.0739 28.5689 31.0267C28.5586 30.9794 28.5593 30.9303 28.571 30.8835L28.6956 29.7918C28.6956 29.724 28.6956 29.687 28.6304 29.6747C28.5651 29.6623 28.5473 29.6747 28.5117 29.7548C28.024 30.3349 27.4164 30.7927 26.7343 31.0939C26.0523 31.3951 25.3136 31.5319 24.5735 31.494C23.3469 31.5483 22.1479 31.1062 21.2283 30.2606C20.7903 29.8085 20.4503 29.2642 20.2314 28.6643C20.0125 28.0643 19.9196 27.4225 19.959 26.7821C19.9647 26.4687 19.9865 26.1558 20.0243 25.8447L21.2935 15.0888C21.3109 14.9858 21.3586 14.891 21.4299 14.8174C21.4631 14.78 21.5035 14.7502 21.5485 14.73C21.5934 14.7098 21.642 14.6997 21.6909 14.7002H25.1666C25.392 14.7002 25.5046 14.8297 25.5046 15.0888L24.3599 24.7346C24.3349 24.9142 24.325 25.0958 24.3303 25.2773C24.2958 25.905 24.4931 26.5227 24.8819 27.0042C25.0827 27.2158 25.3247 27.3803 25.5917 27.4867C25.8587 27.5931 26.1445 27.6388 26.4299 27.6209C27.0813 27.6321 27.7142 27.3952 28.2092 26.9548C28.7177 26.5118 29.072 25.9071 29.2175 25.2341L30.4038 15.0888C30.4316 14.9864 30.4897 14.8958 30.5698 14.8297V14.8297Z"
                        fill="white"
                    />
                    <path
                        d="M37.4571 30.3559C36.9215 30.0341 36.4799 29.5859 36.1741 29.0537C35.8683 28.5215 35.7083 27.9228 35.7094 27.3144C35.6971 27.1443 35.6971 26.9736 35.7094 26.8034L35.7472 26.4871C35.7657 26.3856 35.8164 26.2921 35.8923 26.2195C35.9281 26.1815 35.972 26.1514 36.0211 26.1315C36.0701 26.1115 36.1231 26.1021 36.1763 26.1039H39.7917C39.8417 26.1016 39.8915 26.1105 39.9373 26.13C39.983 26.1496 40.0234 26.1791 40.0553 26.2163C40.0872 26.2535 40.1096 26.2973 40.1208 26.3444C40.132 26.3914 40.1316 26.4403 40.1198 26.4871V26.4871C40.0873 26.7274 40.13 26.9716 40.2424 27.1884C40.3549 27.4051 40.5319 27.5846 40.7508 27.7037C41.3141 28.0519 41.9751 28.224 42.6437 28.1964C43.3083 28.2273 43.9673 28.0664 44.5365 27.7341C44.7552 27.6218 44.9392 27.4557 45.07 27.2527C45.2007 27.0498 45.2735 26.8172 45.2811 26.5784C45.2789 26.4093 45.2243 26.2448 45.1242 26.106C45.0241 25.9672 44.8831 25.8605 44.7195 25.7998C44.1689 25.557 43.5938 25.3695 43.0033 25.2401C42.0358 24.9684 41.2787 24.7251 40.7318 24.5102C39.6992 24.1711 38.7393 23.6538 37.8988 22.9834C37.534 22.6666 37.2481 22.2745 37.0624 21.8363C36.8766 21.3982 36.7959 20.9253 36.8262 20.4529C36.8001 19.3662 37.1362 18.3002 37.7852 17.4114C38.451 16.5179 39.3654 15.8241 40.4227 15.4101C41.6214 14.929 42.9101 14.6909 44.2084 14.7106C45.8217 14.6254 47.4177 15.0669 48.7388 15.9636C49.2676 16.3448 49.6941 16.8424 49.9828 17.4149C50.2715 17.9874 50.4139 18.6181 50.3982 19.2545C50.405 19.4578 50.3944 19.6612 50.3667 19.8628C50.3481 19.9643 50.2974 20.0578 50.2215 20.1305C50.1845 20.1664 50.1402 20.1947 50.0913 20.2136C50.0425 20.2324 49.9902 20.2414 49.9376 20.2399H46.5115C46.4617 20.2415 46.4121 20.2325 46.3664 20.2136C46.3206 20.1946 46.2796 20.1663 46.2465 20.1305C46.2145 20.094 46.192 20.0506 46.1811 20.004C46.1701 19.9575 46.1709 19.909 46.1834 19.8628C46.2052 19.6349 46.1628 19.4055 46.0606 19.1988C45.9584 18.9922 45.8003 18.816 45.6029 18.6888C45.0619 18.3407 44.4152 18.1779 43.7668 18.2265C43.1088 18.1985 42.455 18.3414 41.8739 18.6401C41.6504 18.7435 41.4619 18.9058 41.3302 19.1082C41.1984 19.3106 41.1288 19.5448 41.1293 19.7837C41.1314 19.9739 41.1926 20.159 41.3051 20.3152C41.4176 20.4714 41.5762 20.5914 41.7603 20.6597C42.418 20.9405 43.1028 21.1585 43.8046 21.3105C44.5996 21.4991 45.1549 21.6451 45.483 21.7546C46.6287 22.0641 47.7005 22.5869 48.6378 23.2936C49.0234 23.6176 49.3273 24.0222 49.5263 24.4765C49.7253 24.9308 49.8142 25.4229 49.7862 25.9153C49.7917 26.1186 49.7812 26.3219 49.7546 26.5236C49.6637 27.2632 49.4037 27.9742 48.9935 28.6053C48.5833 29.2364 48.0329 29.772 47.3822 30.1734C45.8322 31.0993 44.0303 31.5569 42.2083 31.4873C40.5427 31.5785 38.8871 31.1843 37.4571 30.3559V30.3559Z"
                        fill="white"
                    />
                    <path
                        d="M65.8264 16.3138C66.2952 16.7764 66.6585 17.3258 66.8936 17.9276C67.1286 18.5295 67.2304 19.1709 67.1925 19.8118C67.1925 20.0048 67.1925 20.3244 67.1226 20.7888L65.7946 31.12C65.776 31.2207 65.7249 31.3134 65.6485 31.3854C65.6125 31.4231 65.5682 31.4529 65.5188 31.4726C65.4694 31.4924 65.4161 31.5018 65.3625 31.5H61.6138C61.3723 31.5 61.2516 31.3733 61.2516 31.12L62.4779 21.7056C62.4915 21.5369 62.4915 21.3676 62.4779 21.1989C62.5056 20.5808 62.2775 19.977 61.8425 19.5163C61.6322 19.3003 61.375 19.1302 61.0887 19.0177C60.8024 18.9053 60.4937 18.8531 60.1841 18.8649C59.809 18.8583 59.4364 18.9231 59.0882 19.0558C58.74 19.1884 58.4234 19.386 58.1572 19.6369C57.5844 20.1973 57.2322 20.9278 57.1597 21.7056L55.9715 31.12C55.9529 31.2207 55.9018 31.3134 55.8254 31.3854C55.7894 31.4231 55.7451 31.4529 55.6957 31.4726C55.6464 31.4924 55.593 31.5018 55.5395 31.5H51.7907C51.7399 31.5016 51.6894 31.4922 51.6431 31.4723C51.5968 31.4524 51.556 31.4227 51.5238 31.3854C51.4916 31.3492 51.469 31.3062 51.4579 31.2601C51.4469 31.2139 51.4477 31.1659 51.4603 31.12L54.2115 9.83041C54.2119 9.77813 54.2247 9.72661 54.2489 9.67965C54.2731 9.63268 54.3081 9.59146 54.3513 9.55901C54.4306 9.48881 54.5351 9.44998 54.6436 9.45045H58.3987C58.448 9.44854 58.497 9.45733 58.5422 9.47614C58.5873 9.49495 58.6273 9.5233 58.6592 9.55901C58.6931 9.59554 58.7171 9.6393 58.7293 9.68656C58.7414 9.73382 58.7414 9.78317 58.7291 9.83041L57.8332 16.7902C57.8296 16.8137 57.8323 16.8377 57.8412 16.8599C57.8501 16.882 57.8649 16.9017 57.884 16.9169C57.884 16.9169 57.9539 16.9169 57.9984 16.8807C58.4876 16.2866 59.1195 15.8123 59.8413 15.4976C60.5632 15.1828 61.3539 15.0367 62.1475 15.0714C62.817 15.0354 63.4873 15.1267 64.1191 15.3401C64.7508 15.5534 65.3313 15.8845 65.8264 16.3138V16.3138Z"
                        fill="white"
                    />
                    <path
                        d="M70.831 31.1678L68.25 15.1597V15.0973C68.2493 15.0453 68.2587 14.9938 68.2778 14.9456C68.2969 14.8973 68.3252 14.8534 68.3612 14.8163C68.4356 14.7435 68.5354 14.7031 68.639 14.7039H72.4117C72.671 14.7039 72.8069 14.8163 72.8316 15.0286L73.8627 24.8807C73.8627 24.9431 73.9183 24.9743 73.9554 24.9743C73.9924 24.9743 74.0356 24.9743 74.0542 24.8807L77.6045 15.0286C77.6383 14.9284 77.7038 14.8423 77.7909 14.7836C77.8779 14.7249 77.9817 14.6969 78.0862 14.7039H81.3772C81.4239 14.6968 81.4716 14.6999 81.5171 14.7128C81.5626 14.7258 81.6048 14.7483 81.641 14.779C81.6772 14.8097 81.7065 14.8478 81.727 14.8909C81.7476 14.9339 81.7588 14.9808 81.76 15.0286L82.995 24.9119C82.995 24.9743 83.0505 25.0055 83.0937 25.0055C83.137 25.0055 83.1678 25.0055 83.1925 24.9119L86.8294 15.0286C86.8652 14.9285 86.932 14.8428 87.0199 14.7843C87.1078 14.7258 87.2121 14.6976 87.3172 14.7039L91.059 14.7726C91.1886 14.7726 91.2751 14.8101 91.3121 14.885C91.337 14.9321 91.35 14.9846 91.35 15.038C91.35 15.0913 91.337 15.1439 91.3121 15.1909L84.8226 31.1678C84.8035 31.2647 84.7506 31.3514 84.6735 31.4121C84.5964 31.4728 84.5004 31.5036 84.4028 31.4987H80.5992C80.5052 31.5056 80.4122 31.4747 80.3406 31.4127C80.2689 31.3508 80.2243 31.2628 80.2164 31.1678L78.858 22.427C78.858 22.3583 78.858 22.3271 78.7962 22.3271C78.7345 22.3271 78.7098 22.3583 78.6666 22.427L75.4743 31.1678C75.451 31.2684 75.3926 31.3573 75.3098 31.418C75.2271 31.4788 75.1255 31.5074 75.0236 31.4987H71.22C71.1253 31.5056 71.0317 31.475 70.959 31.4132C70.8863 31.3513 70.8404 31.2633 70.831 31.1678V31.1678Z"
                        fill="white"
                    />
                    <path
                        d="M102.842 15.0764C102.876 15.0393 102.917 15.0098 102.964 14.9899C103.01 14.9701 103.06 14.9602 103.11 14.9612H106.768C106.818 14.959 106.868 14.9683 106.913 14.9883C106.959 15.0083 106.999 15.0384 107.031 15.0764C107.06 15.1134 107.081 15.1567 107.092 15.2029C107.102 15.2491 107.102 15.297 107.092 15.3432L105.147 30.8612C105.129 30.9625 105.08 31.0557 105.006 31.1281C104.972 31.166 104.929 31.1959 104.882 31.2158C104.835 31.2357 104.784 31.2451 104.732 31.2433H101.123C101.074 31.2449 101.026 31.2354 100.981 31.2154C100.937 31.1955 100.898 31.1656 100.867 31.1281C100.836 31.0917 100.814 31.0485 100.804 31.002C100.793 30.9556 100.794 30.9073 100.806 30.8612L100.964 29.4968C100.964 29.418 100.964 29.3695 100.934 29.3573C100.903 29.3452 100.848 29.3573 100.806 29.4362C100.342 30.0941 99.7201 30.6269 98.9976 30.9868C98.275 31.3466 97.4738 31.5223 96.6661 31.498C95.3868 31.5274 94.145 31.0672 93.197 30.2124C92.2116 29.3043 91.5901 28.0722 91.4472 26.7437C91.3805 26.292 91.3479 25.8359 91.3497 25.3793C91.357 24.6067 91.4099 23.8353 91.5082 23.0689C91.6542 21.6777 91.997 20.3139 92.5264 19.0181C93.0818 17.77 93.9693 16.6964 95.0931 15.9132C96.2094 15.1141 97.5526 14.6893 98.928 14.7004C100.623 14.7004 101.781 15.3068 102.397 16.5196C102.44 16.5863 102.476 16.6167 102.507 16.6167C102.537 16.6167 102.568 16.5742 102.592 16.4893L102.714 15.3189C102.733 15.2279 102.778 15.1439 102.842 15.0764V15.0764ZM101.458 24.7486C101.59 24.218 101.686 23.6791 101.745 23.1356C101.822 22.642 101.863 22.1434 101.867 21.6438C101.856 21.2052 101.793 20.7695 101.678 20.3461C101.595 19.8361 101.336 19.3708 100.946 19.0302C100.535 18.6936 100.015 18.5188 99.4828 18.539C98.8954 18.5298 98.3205 18.7083 97.8428 19.0484C97.3652 19.3866 96.9865 19.8449 96.7453 20.3764C96.345 21.2354 96.1073 22.1605 96.0442 23.1053C95.965 23.6171 95.9222 24.1338 95.9162 24.6516C95.9145 25.0372 95.9679 25.421 96.0747 25.7917C96.153 26.3321 96.4316 26.8239 96.8557 27.1705C97.2798 27.5172 97.8189 27.6937 98.3671 27.6655C98.9455 27.6774 99.5115 27.4982 99.9766 27.1561C100.445 26.801 100.813 26.3308 101.044 25.7917C101.217 25.4587 101.356 25.1093 101.458 24.7486V24.7486Z"
                        fill="white"
                    />
                    <path
                        d="M107.1 37.4018L107.491 34.4297C107.509 34.3264 107.559 34.2312 107.634 34.1573C107.669 34.1186 107.712 34.088 107.761 34.0677C107.809 34.0474 107.861 34.0378 107.914 34.0396C108.903 34.0848 109.889 33.9026 110.796 33.5071C111.523 33.0242 112.047 32.293 112.269 31.4514C112.298 31.3916 112.31 31.3256 112.306 31.2595L109.125 15.1606V15.0305C109.125 14.82 109.243 14.7086 109.479 14.7086H113.406C113.667 14.7086 113.81 14.82 113.828 15.0305L115.146 25.501C115.146 25.5691 115.202 25.6001 115.245 25.6001C115.289 25.6001 115.32 25.6001 115.344 25.501L119.265 15.0244C119.301 14.9251 119.368 14.8401 119.457 14.7821C119.545 14.724 119.65 14.6961 119.756 14.7024H123.614C123.666 14.6957 123.718 14.7045 123.765 14.7277C123.811 14.7508 123.85 14.7873 123.875 14.8324C123.896 14.8848 123.903 14.9412 123.898 14.9971C123.893 15.053 123.874 15.1069 123.844 15.1544L116.314 31.9715C115.785 33.2332 115.098 34.4232 114.27 35.5133C113.608 36.3108 112.737 36.909 111.753 37.2408C110.373 37.6569 108.933 37.8431 107.491 37.7919H107.292C107.162 37.7919 107.1 37.6619 107.1 37.4018Z"
                        fill="white"
                    />
                </svg>

                <div class="info-icon-wrapper" @click="showInfo = !showInfo">
                    <svg
                        class="info-icon"
                        width="35"
                        height="35"
                        viewBox="0 0 35 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83496 0 0 7.83502 0 17.5C0 27.165 7.83496 35 17.5 35ZM15.2593 18.2985C15.0226 18.8835 14.9061 19.5076 14.9165 20.1357L17.2792 20.1461C17.2679 19.8358 17.3463 19.5285 17.5055 19.2589C17.6584 19.0115 17.8556 18.7924 18.0876 18.6117C18.332 18.4178 18.5947 18.2465 18.8723 18.1002C19.1598 17.9471 19.4471 17.7871 19.7346 17.6201C20.0601 17.4263 20.3705 17.21 20.6637 16.9729C20.9326 16.7524 21.1716 16.4999 21.3751 16.2213C21.5782 15.937 21.7339 15.6235 21.8364 15.2923C21.9502 14.909 22.0048 14.5115 21.9982 14.1128C22.0177 13.4652 21.882 12.822 21.6014 12.2338C21.356 11.7388 21.0029 11.3008 20.5668 10.9499C20.1392 10.6186 19.6472 10.3737 19.1202 10.2297C18.5956 10.0777 18.051 10.0004 17.5034 10C17.0238 9.99868 16.5463 10.0583 16.0828 10.1775C15.632 10.292 15.2001 10.4677 14.8 10.6994C14.4061 10.9249 14.0493 11.2064 13.7416 11.5345C13.4292 11.8739 13.1785 12.2622 13 12.6827L14.8734 13.9353C15.0061 13.7365 15.1501 13.5448 15.3046 13.3612C15.4698 13.1599 15.6587 12.9777 15.8672 12.8184C16.0803 12.6549 16.3162 12.5214 16.5677 12.4217C16.8416 12.3143 17.1348 12.2611 17.4301 12.2652C17.6898 12.2652 17.9479 12.3039 18.1954 12.38C18.4396 12.4507 18.6667 12.5678 18.8636 12.7244C19.0522 12.8804 19.2057 13.0722 19.3142 13.2881C19.4347 13.5286 19.4946 13.7933 19.4889 14.0606C19.4952 14.4277 19.3862 14.7881 19.1763 15.094C18.9661 15.3929 18.7076 15.6572 18.411 15.8768C18.118 16.0936 17.8064 16.2856 17.4796 16.451C17.1649 16.6117 16.8998 16.7537 16.6842 16.8789C15.9642 17.2825 15.4891 17.7558 15.2593 18.2985ZM14.9596 22.119V25H17.3525V22.119H14.9596Z"
                        />
                    </svg>
                </div>
            </div>
        </header>
        <div v-if="showInfo" class="info-wrapper">
            <div class="info-inside-wrapper">
                <div @click="showInfo = false" class="close-button-wrapper">
                    <svg
                        class="close-button"
                        width="35"
                        height="35"
                        viewBox="0 0 35 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83496 0 0 7.83502 0 17.5C0 27.165 7.83496 35 17.5 35ZM10.6797 22.6627L15.8418 17.5006L10.6787 12.3375L12.3442 10.672L17.5073 15.8351L22.6715 10.6709L24.337 12.3364L19.1729 17.5006L24.3361 22.6638L22.6705 24.3293L17.5073 19.1661L12.3452 24.3282L10.6797 22.6627Z"
                        />
                    </svg>
                </div>
                <div class="info">
                    <div class="info-content">
                        <h2>Über dieses Projekt</h2>
                        <p class="projekt-beschreibung">
                            Willkommen bei flushway. Was passiert mit deinem
                            Abwasser, wenn du die Spültaste drückst? In unserem
                            Webprojekt wird der Weg deines Abwassers, wenn es
                            dein zu Hause verlässt, auf einer Karte ersichtlich.
                            Der Weg verläuft von deinem Haus, durch die
                            Kanalisation, zur Kläranlage und schlussendlich in
                            die Reuss. Den Ablauf in der Kläranlage haben wir
                            illustriert und beschrieben, damit du verstehst, wie
                            dein Abwasser gereinigt wird.
                        </p>
                        <div class="ueber-wrapper">
                            <div class="ueber">
                                <p class="bold">Modul Web Studio 1</p>
                                <p>Herbstsemester 2020</p>
                                <p>Digital Ideation</p>
                                <p>Hochschule Luzern</p>
                            </div>
                            <div class="ueber">
                                <p class="bold">Dozent*innen</p>
                                <p>Maria Husmann</p>
                                <p>Hanna Züllig</p>
                            </div>
                            <div class="ueber">
                                <p class="bold">Student*innen</p>
                                <p>Simon Müller</p>
                                <p>Chiara Kühne</p>
                                <p>Silja Bossert</p>
                            </div>
                        </div>
                        <p class="github">
                            <a
                                href="https://github.com/seimon-m/flushway"
                                target="_blank"
                                >Projekt auf Github</a
                            >
                        </p>

                        <h2>Quellen</h2>
                        <p>
                            <a
                                href="https://www.real-luzern.ch/abwasser/"
                                target="_blank"
                                >REAL Luzern (Infos von einer Besichtigung und
                                der Webseite)</a
                            >
                        </p>
                        <p>
                            <a
                                href="https://www.energie-umwelt.ch/haus/trink-und-abwasser"
                                target="_blank"
                                >Amt für Umwelt und Energie Webseite</a
                            >
                        </p>
                        <p>
                            <a
                                href="https://vsa.ch/wp-content/uploads/2020/07/Branchenbericht_VSA_DE_LR.pdf"
                                target="_blank"
                                >VSA Branchenbericht</a
                            >
                        </p>
                        <p>
                            <a
                                href="https://www.ewl-luzern.ch/privatkunden/wasser/"
                                target="_blank"
                                >EWL Luzern Webseite</a
                            >
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="start">
            <div class="start-content">
                <h1>
                    WOHIN FLIESST DEIN <span class="font-color">ABWASSER</span>,
                    WENN DU SPÜHLST?
                </h1>
                <form class="demo" role="adress">
                    <label for="search" class="hidden-visually"
                        >Adresse:
                    </label>
                    <input
                        type="text"
                        name="adress"
                        id="adress"
                        placeholder="Gib deine Adresse ein ..."
                    />
                    <button
                        id="button"
                        type="button"
                        @click="$emit('set-start')"
                    >
                        Flush
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Start",
    data() {
        return {
            showInfo: false,
        };
    },
    mounted() {
        let button = document.getElementById("button");
        button.onclick = function() {
            window.scrollTo({
                top: window.innerHeight,
                left: 0,
                behavior: "smooth",
            });
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.start-wrapper {
    height: 100vh;
    width: 100vw;

    background-color: rgba(36, 36, 36, 0.5);
    backdrop-filter: blur(8px);
}

.start {
    height: 100vh;
    margin-top: -100px;
    display: flex;
    align-items: center;
}

.start-content {
    /* max-width: 1100px; */
    max-width: 1200px;
    padding-right: 100px;
    padding-left: 100px;

    margin-left: auto;
    margin-right: auto;
}

h1 {
    margin-bottom: 30px;
}

.font-color {
    color: #5ff4f4;
}

input {
    width: 380px;
    height: 60px;
    border-radius: 30px 0px 0px 30px;
    padding-left: 30px;
    font-weight: 600;
}

button {
    width: 200px;
    height: 60px;
    border-radius: 30px 30px 30px 30px;
    background-color: #5ff4f4;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    margin-left: -30px;
}

button:hover {
    background-color: #5bd6d6;
}

.hidden-visually {
    position: absolute;
    overflow: hidden;
    white-space: nowrap;
    margin: 0;
    padding: 0;
    height: 1px;
    width: 1px;
    clip: rect(0 0 0 0);
    clip-path: inset(100%);
}

header {
    height: 100px;
    width: 100vw;
    top: 0;
}

.content-header {
    height: 100px;
    padding-right: 100px;
    padding-left: 100px;

    margin-left: auto;
    margin-right: auto;

    display: flex;
    justify-content: space-between;
    align-items: center;
}

.info-icon-wrapper {
    height: 35px;
}

.info-icon {
    cursor: pointer;
    fill: white;
}
.info-icon:hover {
    fill: #c4c3c3;
}

.info-wrapper {
    position: absolute;
    width: 100vw;
    height: 100vh;
    margin: auto;
    background-color: rgba(36, 36, 36, 0.95);
    backdrop-filter: blur(8px);
    z-index: 2;
    margin-top: -100px;

    /*position: fixed;
    top: 0;*/
}

.info-inside-wrapper {
    padding-right: 100px;
    padding-left: 100px;

    height: 100vh;
}

.info {
    max-width: 1200px;

    margin-left: auto;
    margin-right: auto;

    height: 100vh;
    margin-top: -100px;
    display: flex;
    align-items: center;
}

.info-content {
}

h2 {
    margin-bottom: 30px;
}

.bold {
    font-weight: 800;
    color: rgba(255, 255, 255, 1);
    margin-bottom: 10px;
}

p {
    line-height: 1.5;
}

a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-weight: bold;
    line-height: 1.5;
}

a:hover {
    color: #5bd6d6;
}

.ueber-wrapper {
    display: flex;
}

.ueber {
    margin-right: 50px;
}

.github {
    margin-top: 40px;
    margin-bottom: 70px;
}

.close-button-wrapper {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.close-button {
    fill: white;
    cursor: pointer;
}

.close-button:hover {
    fill: #c4c3c3;
}

.projekt-beschreibung {
    margin-bottom: 20px;
    color: rgba(255, 255, 255, 1);
}
</style>
